interface AboutQuebonHeroProps {
  label: string
  subtitle: string
  title: string
  description: string
  descriptionHighlight: string
}

export function AboutQuebonHero({
  label,
  subtitle,
  title,
  description,
  descriptionHighlight,
}: AboutQuebonHeroProps) {
  return (
    <section id="hero" data-marketing-section="" className="w-full bg-qb-bg">
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0 pt-10 pb-20 lg:pt-20 lg:pb-40">
        <div className="flex flex-col items-center gap-10 tracking-[-0.6px] text-center">
          <div className="flex flex-col items-center gap-4 lg:gap-6">
            <p className="font-bold text-qb-primary text-[16px] lg:text-[24px] leading-[1.5] lg:leading-[1.4]">
              {label}
            </p>
            <p className="font-medium text-qb-text-high text-[20px] lg:text-[36px] leading-[1.5] lg:leading-[1.2] whitespace-pre-line">
              {subtitle}
            </p>
            <h1 className="font-bold lg:font-extrabold text-qb-text-high text-[32px] lg:text-[56px] leading-[1.4] lg:leading-[1.2] whitespace-pre-line">
              {title}
            </h1>
          </div>
          <div className="flex flex-col items-center gap-4 px-6 lg:px-0 max-w-[720px]">
            <p className="font-normal text-qb-text-mid text-[18px] lg:text-[20px] leading-[1.5] whitespace-pre-line">
              {description}
            </p>
            <p className="font-semibold text-qb-text-high text-[20px] lg:text-[24px] leading-[1.5] lg:leading-[1.4] whitespace-pre-line">
              {descriptionHighlight}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
